import { APP_DEFINITION_ID, PageMap } from '@wix/wixstores-client-core';
import { EcomPlatformViewerScriptContext } from '../../viewer-script/types';
import type { GetCheckoutUrlParams, GetCheckoutUrlResult } from '../types';

export const getCheckoutUrl =
  ({ context }: { context: EcomPlatformViewerScriptContext }) =>
  async (urlParams: GetCheckoutUrlParams): Promise<GetCheckoutUrlResult> => {
    const { url, relativeUrl } = await context.wixApi!.site.getSectionUrl({
      sectionId: PageMap.CHECKOUT,
      appDefinitionId: APP_DEFINITION_ID,
    });

    const queryString = Object.entries(urlParams)
      .filter(([_, value]) => !!value)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`,
      )
      .join('&');

    return {
      url: `${url}?${queryString}`,
      relativeUrl: `${relativeUrl}?${queryString}`,
    };
  };
